<template lang="pug">
  header.margin-top-15
</template>

<script>
export default {
  name: "Header"
};
</script>

<style>
.app-icon {
  width: 100%;
  margin-bottom: 20px;
}

.hvu-logo a:hover,
a:active,
a:focus {
  background-color: #ffffff;
}
</style>
